module.exports = __webpack_public_path__ + "img/tool_circle.51113639.svg";